export default "__VITE_ASSET__l2D17bYc__"